export const STATUS_ORDER =[
    "Draft",
    "Submitted",
    "Under Review",
    "Needs Revision",
    "Awaiting Approval",
    "Awaiting Deposit",
    "Approved",
    "Estimate",
    "Work Order",
    "On Hold",
    "Rejected",
    "Completed",
    "Closed"
  ];
 

  export const STATUS_RULES = {
    "Draft": {
      canEdit: true,
      isCompleted: false,
      canDelete: true,
      canSubmit: true,
      nextStatuses: ["Submitted"],
      cannotGoBack: true
    },
    "Submitted": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Under Review", "On Hold"],
      cannotGoBack: true
    },
    "Under Review": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Needs Revision", "On Hold", "Awaiting Approval", "Awaiting Deposit"],
      cannotGoBack: false
    },
    "Needs Revision": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Under Review", "Rejected", "On Hold"],
      cannotGoBack: false
    },
    "Awaiting Approval": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Under Review", "Needs Revision", "Approved", "Rejected"],
      cannotGoBack: true
    },
    "Awaiting Deposit": {
      canEdit: true,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Under Review", "Awaiting Approval", "Approved", "Rejected"],
      cannotGoBack: true
    },
    "Approved": {
      canEdit: false,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Under Review", "Needs Revision", "Awaiting Approval", "Awaiting Deposit", "Work Order", "Rejected"],
      cannotGoBack: true
    },
    "Work Order": {
      canEdit: false,      
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    },
    "On Hold": {
      canEdit: false,
      isCompleted: false,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Under Review", "Rejected"],
      cannotGoBack: true
    },
    "Rejected": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    },
    "Completed": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: ["Closed"],
      cannotGoBack: true
    },
    "Closed": {
      canEdit: false,
      isCompleted: true,
      canDelete: false,
      canSubmit: false,
      nextStatuses: [],
      cannotGoBack: true
    }
  };
  
  

  
export const getStatusRules = (currentStatus) => {
  return STATUS_RULES[currentStatus] || {};
};
  
// const currentStatus = "Under Review";
// const rules = getStatusRules(currentStatus);

// console.log("Can Edit:", rules.canEdit); // true
// console.log("Next Status Options:", rules.nextStatuses); // ["Assessment / Estimate / Work Order", "On Hold", "Canceled"]

export const canTransition = (currentStatus, nextStatus) => {
    const rules = getStatusRules(currentStatus);
    return rules.nextStatuses.includes(nextStatus);
  };
  
// const nextStatus = "Submitted";
// if (canTransition(currentStatus, nextStatus)) {
//   console.log("Transition allowed");
// } else {
//   console.log("Transition NOT allowed");
// }
